import { createContext, useContext, useEffect, useState } from "react";
import { it as dfIt, de as dfDe, fr as dfFr, enUS as dfEn } from "date-fns/locale";
import { STRINGS } from "./translations";

export const LANGS = [
  { code: "it", label: "IT" },
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
];

export const dfLocale = { it: dfIt, de: dfDe, en: dfEn, fr: dfFr };

const LanguageContext = createContext({ lang: "it", setLang: () => {}, t: (s) => s });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("nx-lang") || "it";
    } catch {
      return "it";
    }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    try {
      localStorage.setItem("nx-lang", l);
    } catch {}
    setLangState(l);
  };

  const t = (s) => (lang === "it" ? s : STRINGS[lang]?.[s] ?? s);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
